export default __webpack_public_path__ + "static/media/undergraduate.992fd3bd.svg";